/**
 * Settings → Konto, for a person with no farm: the Betrieb pane, which closes with deleting the
 * account, is not shown to them, and that deletion must stay reachable for everyone.
 */
import { useTranslation } from 'react-i18next';
import { SettingsPane } from '@hofsync/design-system';
import AccountDeletionSection from './AccountDeletionSection';
import type { SettingsPaneChrome } from './paneChrome';

export default function AccountPane({ backLink, focusOnMount }: SettingsPaneChrome) {
    const { t } = useTranslation();
    return (
        <SettingsPane title={t('settings.account.title', 'Konto')} backLink={backLink} focusOnMount={focusOnMount}>
            <AccountDeletionSection />
        </SettingsPane>
    );
}
